import { forwardRef } from "react";

export const Checkbox = forwardRef<HTMLInputElement, {
  checked: boolean;
  onChange: () => void;
  ariaLabel: string;
}>(({ checked, onChange, ariaLabel }, ref) => {
  return (
    <input
      ref={ref}
      type="checkbox"
      checked={checked}
      onChange={onChange}
      className="border-border size-4 rounded accent-primary cursor-pointer"
      aria-label={ariaLabel}
    />
  );
});
